import axios from 'axios';
import AuthService from '../services/authorization';
import constants from '../constants';

export const logActivity = async (customerNumber: string, values: any, service: string) => {
  try {
    const authService = new AuthService();
    const userId = authService.getUserId();

    const response = await axios.get(constants.IP_LOCATOR);
    const ipAddress = response.data.ip || null;
    const data = values;

    data.service = service;
    data.user_id = String(userId);
    data.customer_number = customerNumber;
    data.ip_address = ipAddress.slice(0, 15);

    axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/activity-log`, data);
  } catch (error) {
    console.error(error);
  }
};
